import React, { ReactNode } from 'react';

import useCioBrowseAndGqlProducts from '../hooks/useCioBrowseAndGqlProducts';

import SlicedGridProvider from './SlicedGridProvider';

interface CIOBrowseProviderProps {
  children: ReactNode;
}

export const CIOBrowseProvider = ({ children }: CIOBrowseProviderProps) => {
  const cioData = useCioBrowseAndGqlProducts();

  return <SlicedGridProvider data={cioData}>{children}</SlicedGridProvider>;
};
